<template>
<div>
  <transition v-show="transfer" class="font-poppins" name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal w-1/3 md:w-full md:m-2 rounded-lg"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header text-center"
          id="modalTitle"
        >
          <slot name="header">
            Confirm
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            x
          </button>
        </header>

        <section
          class="modal-body text-center "
          id="modalDescription"
        >
          <slot name="body">
            Are you sure you want to send NGN{{amount}} to {{accountName}} {{bankAccountName}} 
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            
          </slot>
          <div class="flex justify-center">
            <div class="w-1/3 bg-blue-700 p-2 text-white  text-center rounded-lg">
                <button
                  type="button"
                  @click="transferMoney"
                  aria-label="Close modal"
              >
                  YES
              </button>
                <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-white"></i>    
            </div>
            
            <button
                type="button"
                class="bg-white border p-2 rounded-lg w-1/3 shadow-lg ml-4"
                @click="close"
                aria-label="Close modal"
            >
                NO
            </button>
          </div>
          
        </footer>
      </div>
    </div>
  </transition>

  <div>
    <SuccessModal
      v-show="isModalVisible"
      @close="closeModal"
    />
  </div>
  <TransferFailed
  v-show="failed"
  @off="offModal"
  :message="message"
  />
</div>
</template>

<script>
import axios from 'axios';
import SuccessModal from './SuccessModal.vue';
import TransferFailed from './TransferFailed.vue';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
  export default {
  components: { 
    SuccessModal,
    TransferFailed
    },
    name: 'Modal',
    props: [
      "receiver",
      "accountNumber",
      "code",
      "bank",
      "amount",
      "description",
      "accountName",
      "password",
      "medium",
      "bankAccountName"
    ],
    data() {
      return {
        userId : localStorage.getItem("userId"),
        isLoading: false,
        isModalVisible: false,
        transfer:true,
        failed: false,
        message: "",
        token: localStorage.getItem("userId")
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      off() {
        this.$emit('off');
        console.log("off")
      },

      closeModal() {
        this.isModalVisible = false;
      },
      offModal() {
        this.failed = false;
      },

      transferMoney() {
        this.isLoading = true;
        axios({
              method: 'POST',
              url: `${url}/v1/web/transactions/transfer`,
              headers: {
                  'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
              },
              data : {
                  userId: this.userId,
                  amount: this.amount,
                  accountNumber: this.accountNumber,
                  recieverName: this.accountName,
                  bankName:this.bank,
                  description: this.description,
                  password: this.password,
                  bankCode: this.code,
                  transfer: this.medium,
                  recipient: this.accountNumber
              }
          })
          .then((res) => {
            this.transfer = false;
            this.isModalVisible = true;
            res.json;
          })
          .catch((err) => {
            this.transfer = false;
            this.message = err.response.data.message;
            this.failed = true
            err.json
          })
      }
      
      
    },
  };
</script>

<style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>